





































import Vue from 'vue';
import util from '@/components/util';
import NOC from '@/class/common/const';
import API from '@/api/common';
import * as models from '@/class/models/views/account';

export default Vue.extend({
  name: 'ModalLicenceApplication',
  components: { ...util},
  props: {
    selectPayment: Number,

    payment: Number,
  },
  data() {
    return { accountData: {} as models.IAccount };
  },
  async mounted() {
    const api = new API();
    const res = await api.get<models.IAccount>('account');

    if (res.result) {
      this.accountData = res.data;
      this.accountData.noTaxPrice = Math.ceil(this.accountData.taxPrice / 11 * 10);
  }},
  methods: {
    onClickClose() {
      this.$emit('close');
    },
    onClickChangePlan() {
      let token = '';
      if (this.selectPayment === this.CREDIT) {
      // if (this.payment === this.CREDIT) {
        const payjpToken: any = document.getElementsByName('payjp-token')[0];
        token = payjpToken.value;
      }

      this.$emit('onClickConfirmation', { payment: this.selectPayment, token });
    },
  },
  computed: {
    NOSELECT(): number {
      return NOC.PAYMENT.NOSELECT;
    },
    CREDIT(): number {
      return NOC.PAYMENT.CREDIT;
    },
    BANK(): number {
      return NOC.PAYMENT.BANK;
    },
  },
});
